var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/index.ts
import { z as z27 } from "zod";

// src/utils.ts
import { z } from "zod";
var resolutionSchema = z.enum(["second", "minute", "hour", "day", "week", "month", "quarter", "year"]).default("day");
var relativePeriodSchema = z.enum(["today", "week", "thisweek", "month", "thismonth", "thisquarter", "thisyear"]);
var dateTimeSchema = z.string().datetime({ offset: true });
var dateRangeSchema = z.object({
  startDate: dateTimeSchema,
  endDate: dateTimeSchema
});

// src/consumption-corrections.ts
var consumption_corrections_exports = {};
__export(consumption_corrections_exports, {
  CORRECTION_EVENTS: () => CORRECTION_EVENTS,
  consumptionCorrectionTagSchema: () => consumptionCorrectionTagSchema,
  correctionFillPayloadSchema: () => correctionFillPayloadSchema,
  indexPointSchema: () => indexPointSchema,
  isAutoCorrection: () => isAutoCorrection,
  manualDataSourceConfigSchema: () => manualDataSourceConfigSchema,
  parseCorrectionTag: () => parseCorrectionTag
});
import { z as z2 } from "zod";
import * as _ from "lodash-es";
var consumptionCorrectionTagSchema = z2.object({
  origin: z2.literal("auto"),
  meterDataSourceID: z2.string().uuid().toLowerCase(),
  deviceID: z2.string()
});
var manualDataSourceConfigSchema = z2.object({
  correction: consumptionCorrectionTagSchema.optional().catch(void 0)
});
var parseCorrectionTag = (config) => consumptionCorrectionTagSchema.safeParse(_.get(config, "correction")).data ?? null;
var isAutoCorrection = (config) => parseCorrectionTag(config) !== null;
var indexPointSchema = z2.object({
  at: z2.string().datetime({ offset: true }),
  valueM3: z2.number()
});
var correctionFillPayloadSchema = z2.object({
  consumption: z2.number(),
  fill: z2.object({
    id: z2.string().uuid(),
    deviceID: z2.string(),
    missingM3: z2.number(),
    before: indexPointSchema,
    after: indexPointSchema,
    slotMinutes: z2.number().int().positive()
  })
});
var CORRECTION_EVENTS = {
  meterDriftDetected: "meter_drift_detected",
  correctionApplied: "consumption_correction_applied",
  shaypDriftAlignCompleted: "shayp_drift_align_completed"
};

// src/access-policies.ts
var access_policies_exports = {};
__export(access_policies_exports, {
  accessPolicyInputSchema: () => accessPolicyInputSchema,
  accessPolicySchema: () => accessPolicySchema,
  inheritedFromSchema: () => inheritedFromSchema,
  memberRoleSchema: () => memberRoleSchema,
  orgMemberScopeSchema: () => orgMemberScopeSchema,
  permissionSchema: () => permissionSchema,
  resourceTypeSchema: () => resourceTypeSchema
});
import { z as z3 } from "zod";
var memberRoleSchema = z3.enum(["admin", "collaborator"]);
var resourceTypeSchema = z3.enum(["site", "group"]);
var permissionSchema = z3.enum(["read", "write"]);
var accessPolicySchema = z3.object({
  id: z3.string().uuid(),
  memberID: z3.string().uuid(),
  resourceType: resourceTypeSchema,
  resourceID: z3.string().uuid(),
  permission: permissionSchema,
  createdAt: dateTimeSchema
});
var accessPolicyInputSchema = accessPolicySchema.omit({
  id: true,
  memberID: true,
  createdAt: true
});
var orgMemberScopeSchema = z3.object({
  resourceType: resourceTypeSchema,
  resourceID: z3.string()
});
var inheritedFromSchema = z3.object({
  groupID: z3.string(),
  groupName: z3.string(),
  permission: permissionSchema
});

// src/plugins/index.ts
var plugins_exports = {};
__export(plugins_exports, {
  WorksheetExtractionSchema: () => WorksheetExtractionSchema,
  WorksheetSchema: () => WorksheetSchema,
  WorksheetStatusSchema: () => WorksheetStatusSchema
});

// src/plugins/eiffage-scans.ts
import { z as z4 } from "zod";
var WorksheetStatusSchema = z4.enum(["new", "pending", "processing", "validation", "completed", "failed"]);
var MatchInfo = z4.object({
  matched_id: z4.string().uuid().nullable().describe(
    "The official ID that is used in our system, has to be a UUID it is critical, DO NOT FORGE IT. If there is no good match, set to null."
  ),
  matched_name: z4.string().nullable(),
  confidence: z4.number().min(0).max(1),
  raw_text: z4.string().nullable()
});
var GridMap = z4.object({
  pump_station: MatchInfo.describe("Result of the fuzzy matching against the PUMP_CATALOG."),
  usage_station: MatchInfo.describe("Result of the fuzzy matching against the USAGE_CATALOG."),
  checkbox_grid: z4.array(z4.boolean()).length(16).describe(
    "Exactly 16 boolean values representing the 16 checkboxes in this pump\xD7usage cell. Position 0 = top-left, Position 15 = bottom-right, read left-to-right, top-to-bottom (row-major). true = handwritten mark present, false = empty or only printed grid."
  ),
  grid_raw_text: z4.string().describe("The raw OCR text from the 16-checkbox grid area in this cell, used for debugging."),
  notes: z4.string().optional().default("")
}).describe(
  "One entry per cell in the grid, at the intersection of a pump station and a usage station. Each cell contains exactly 16 checkboxes."
);
var DayBlock = z4.object({
  weekday: z4.enum(["LUNDI", "MARDI", "MERCREDI", "JEUDI", "VENDREDI"]).describe("Day of the week, in French"),
  date: z4.string().describe("Date of the reading, must absolutely be in ISO format (e.g. 2025-09-17"),
  gridMaps: z4.array(GridMap),
  warnings: z4.array(z4.string()).default([])
});
var WorksheetHeader = z4.object({
  tank_volume: z4.number().nullable().describe('The tank volume in m\xB3, extracted from "Volume du r\xE9servoir"'),
  tank_volume_raw: z4.string().nullable(),
  week_number_raw: z4.number().nullable(),
  driver_name: z4.string().nullable()
});
var WorksheetExtractionSchema = z4.object({
  header: WorksheetHeader,
  days: z4.array(DayBlock).length(5).describe("Exactly five day blocks"),
  page_quality: z4.number().min(0).max(1),
  warnings: z4.array(z4.string()).default([])
});
var WorksheetSchema = z4.object({
  ID: z4.number().int(),
  name: z4.string(),
  createdAt: z4.string().datetime({ offset: true }),
  processedAt: z4.string().datetime({ offset: true }).nullable(),
  importedAt: z4.string().datetime({ offset: true }).nullable(),
  workWeekDate: z4.string().datetime({ offset: true }),
  orgID: z4.string().uuid(),
  siteID: z4.string().uuid(),
  status: WorksheetStatusSchema,
  entryStations: z4.array(z4.string().uuid()).min(1),
  usageStations: z4.array(z4.string().uuid()).min(1),
  extractedData: WorksheetExtractionSchema.nullable(),
  verifiedData: WorksheetExtractionSchema.nullable()
});

// src/custom-pages/index.ts
var custom_pages_exports = {};
__export(custom_pages_exports, {
  customPageSchema: () => customPageSchema,
  customPagesConfigSchema: () => customPagesConfigSchema,
  customPagesFor: () => customPagesFor
});

// src/custom-pages/pages.ts
var CUSTOM_PAGES = {
  orgPages: [
    {
      orgID: "b54329a9-fe86-4117-b3ef-d962eadb9c8c",
      posthogDashboardID: 1030004,
      labelKey: "navigation.customPages.deployment",
      placement: "trailing"
    },
    {
      orgID: "b54329a9-fe86-4117-b3ef-d962eadb9c8c",
      posthogDashboardID: 1030005,
      labelKey: "navigation.customPages.consumption",
      placement: "trailing"
    }
  ],
  sitePages: []
};

// src/custom-pages/schema.ts
import { z as z5 } from "zod";
var customPageSchema = z5.object({
  posthogDashboardID: z5.number().int().positive(),
  labelKey: z5.string(),
  placement: z5.enum(["leading", "trailing"])
});
var orgPageSchema = customPageSchema.extend({ orgID: z5.string().uuid() });
var customPagesConfigSchema = z5.object({
  orgPages: z5.array(orgPageSchema),
  sitePages: z5.array(orgPageSchema.extend({ siteID: z5.string().uuid() }))
});

// src/custom-pages/index.ts
var toView = ({ posthogDashboardID, labelKey, placement }, siteID) => ({
  posthogDashboardID,
  labelKey,
  placement,
  siteID
});
var customPagesFor = (orgID) => [
  ...CUSTOM_PAGES.orgPages.filter((page) => page.orgID === orgID).map((page) => toView(page, null)),
  ...CUSTOM_PAGES.sitePages.filter((page) => page.orgID === orgID).map((page) => toView(page, page.siteID))
];

// src/stations.ts
var stations_exports = {};
__export(stations_exports, {
  LeakTriggerConfigSchema: () => LeakTriggerConfigSchema,
  RainfallStationSchema: () => RainfallStationSchema,
  StationLeakTriggersConfigSchema: () => StationLeakTriggersConfigSchema,
  WaterLevelStationSchema: () => WaterLevelStationSchema,
  WaterStationSchema: () => WaterStationSchema,
  WaterStationSummarySchema: () => WaterStationSummarySchema,
  WaterStationWithSiteSchema: () => WaterStationWithSiteSchema,
  collectionRuleSchema: () => collectionRuleSchema,
  collectionRulesSetSchema: () => collectionRulesSetSchema,
  createRainfallStationSchema: () => createRainfallStationSchema,
  createWaterLevelStationSchema: () => createWaterLevelStationSchema,
  createWaterStationSchema: () => createWaterStationSchema,
  stationTypeSchema: () => stationTypeSchema,
  stationUISchema: () => stationUISchema,
  waterTypeSchema: () => waterTypeSchema
});
import { z as z6 } from "zod";
var LeakTriggerConfigSchema = z6.object({
  enabled: z6.boolean(),
  percentThreshold: z6.number().min(0).max(1),
  volumeThreshold: z6.number().min(0)
});
var StationLeakTriggersConfigSchema = z6.object({
  "new-leak": LeakTriggerConfigSchema,
  "leak-update": LeakTriggerConfigSchema,
  "leak-resolved": LeakTriggerConfigSchema
});
var stationUISchema = z6.object({
  position: z6.object({
    x: z6.number(),
    y: z6.number()
  }),
  color: z6.string()
});
var stationTypeSchema = z6.enum(["entry", "usage", "discharge"]);
var waterTypeSchema = z6.enum(["city", "surface", "underground", "rain", "recycled", "used"]);
var WaterStationSchema = z6.object({
  id: z6.string().uuid(),
  // Discriminant against WaterLevelStation; defaulted so parse inputs that
  // predate the column (fixtures, narrow selects) stay valid.
  measurement_type: z6.literal("water_volume").default("water_volume"),
  name: z6.string().min(2),
  description: z6.string().default(""),
  station_type: stationTypeSchema,
  water_type: waterTypeSchema.nullable(),
  site_id: z6.string(),
  cost: z6.number().nullable(),
  expectedEndOfLife: z6.string().date().nullable().default(null),
  internalID: z6.string().nullable(),
  ui: stationUISchema.partial(),
  leakTriggerConfig: StationLeakTriggersConfigSchema,
  tags: z6.array(z6.string()),
  dataSources: z6.array(
    z6.object({
      id: z6.string().uuid(),
      type: z6.string(),
      // Untyped here on purpose: MeterConfigSchema lives in ./index, which
      // re-exports this file as `Stations`, so a direct import would be circular.
      // Callers cast to MeterConfig after narrowing by `type === 'meter'`.
      config: z6.unknown().nullable()
    })
  ).optional()
});
var WaterStationSummarySchema = WaterStationSchema.omit({ leakTriggerConfig: true });
var createWaterStationSchema = WaterStationSchema.omit({
  id: true,
  measurement_type: true,
  ui: true,
  leakTriggerConfig: true,
  tags: true
}).strict();
var StationIdentitySchema = WaterStationSchema.pick({
  id: true,
  name: true,
  description: true,
  site_id: true,
  internalID: true,
  ui: true,
  tags: true,
  dataSources: true
});
var WaterLevelStationSchema = StationIdentitySchema.extend({
  measurement_type: z6.literal("water_level")
});
var createWaterLevelStationSchema = WaterLevelStationSchema.omit({
  id: true,
  measurement_type: true,
  ui: true,
  tags: true
}).strict();
var RainfallStationSchema = StationIdentitySchema.extend({
  measurement_type: z6.literal("rainfall")
});
var createRainfallStationSchema = RainfallStationSchema.omit({
  id: true,
  measurement_type: true,
  ui: true,
  tags: true
}).strict();
var ruleInclusionOperationSchema = z6.enum(["include", "exclude"]).describe("Whether to include or exclude the matching stations");
var matcherOperationSchema = z6.discriminatedUnion("operation", [
  z6.object({
    operation: z6.literal("$eq").describe("Use when the field is single-valued and needs to match exactly one value"),
    value: z6.union([z6.string(), z6.literal("$any")]).describe("The value to match against, use $any for universal matching")
  }),
  z6.object({
    operation: z6.literal("$in").describe("Use when the field is single-valued and needs to match one of several possible values"),
    value: z6.array(z6.string()).min(1).describe("The possible values to match against, cannot accept $any")
  }),
  z6.object({
    operation: z6.literal("$has").describe("Use when the field is multi-valued (an array) and needs to contain one of the values"),
    value: z6.string().describe("The value to match against, cannot accept $any")
  })
]);
var entityMatcherSchema = z6.discriminatedUnion("entity", [
  z6.object({
    entity: z6.literal("site").describe("Matching a site property"),
    property: z6.enum(["tags", "internalID", "groupIDs"])
  }),
  z6.object({
    entity: z6.literal("station").describe("Matching a station property"),
    property: z6.enum(["tags", "site_id", "station_type", "water_type"])
  })
]);
var dynamicRuleSchema = z6.object({
  type: z6.literal("dynamic"),
  inclusion: ruleInclusionOperationSchema,
  entity: entityMatcherSchema,
  matcher: matcherOperationSchema
});
var staticRuleSchema = z6.object({
  type: z6.literal("static"),
  inclusion: ruleInclusionOperationSchema,
  stations: z6.array(z6.string()).describe("The station IDs to include or exclude.")
});
var collectionRuleSchema = z6.discriminatedUnion("type", [dynamicRuleSchema, staticRuleSchema]);
var collectionRulesSetSchema = z6.array(collectionRuleSchema);
var WaterStationWithSiteSchema = WaterStationSchema.extend({
  site: z6.object({
    id: z6.string().uuid(),
    name: z6.string(),
    internalID: z6.string().nullable(),
    tags: z6.array(z6.string()),
    coordinates: z6.object({
      lat: z6.number().describe("Latitude coordinate"),
      lng: z6.number().describe("Longitude coordinate")
    }).nullable().describe("Geographic coordinates of the site")
  })
});

// src/sites.ts
var sites_exports = {};
__export(sites_exports, {
  SilentDeviceConfigSchema: () => SilentDeviceConfigSchema,
  createSiteSchema: () => createSiteSchema,
  siteSchema: () => siteSchema,
  siteStatusSchema: () => siteStatusSchema
});
import { z as z7 } from "zod";
var SilentDeviceConfigSchema = z7.object({
  enabled: z7.boolean(),
  config: z7.object({
    silenceTimeThreshold: z7.number().min(0),
    reminderTimeInterval: z7.number().min(0),
    resolutionStabilityTime: z7.number().min(0)
  })
});
var siteStatusSchema = z7.enum(["active", "inactive"]);
var siteSchema = z7.object({
  id: z7.string(),
  name: z7.string(),
  description: z7.string().nullable(),
  address: z7.string(),
  orgID: z7.string(),
  internalID: z7.string().nullable(),
  coordinates: z7.object({
    lat: z7.number(),
    lng: z7.number()
  }).nullable(),
  droughtIncidentEnabled: z7.boolean(),
  budgetOverageIncidentEnabled: z7.boolean().optional(),
  silentDeviceConfig: SilentDeviceConfigSchema.optional(),
  tags: z7.array(z7.string())
});
var createSiteSchema = siteSchema.omit({
  id: true,
  droughtIncidentEnabled: true,
  budgetOverageIncidentEnabled: true,
  tags: true
});

// src/data-lake.ts
var data_lake_exports = {};
__export(data_lake_exports, {
  dataLakeDatapointSchema: () => dataLakeDatapointSchema,
  insertDataLakeBatchSchema: () => insertDataLakeBatchSchema
});
import * as _2 from "lodash-es";
import { z as z8 } from "zod";
var atLeastOneLeafIsNumber = (obj) => {
  return _2.values(obj).some((val) => _2.isObject(val) ? atLeastOneLeafIsNumber(val) : _2.isNumber(val));
};
var dataLakeDatapointSchema = z8.object({
  deviceID: z8.string().min(1, "deviceID is required"),
  timestamp: z8.string().datetime({ offset: true, message: "timestamp must be a valid ISO 8601 timestamp with timezone" }),
  payload: z8.object({}).passthrough().refine(atLeastOneLeafIsNumber, { message: "payload must contain at least one numeric value" })
});
var insertDataLakeBatchSchema = z8.object({
  datapoints: z8.array(dataLakeDatapointSchema).min(1, "At least one datapoint required").max(1e3, "Maximum 1000 datapoints per request"),
  conflictStrategy: z8.enum(["overwrite", "ignore", "error"]).default("overwrite"),
  source: z8.string().optional()
});

// src/ftp.ts
var ftp_exports = {};
__export(ftp_exports, {
  FtpFormatProfileSchema: () => FtpFormatProfileSchema,
  FtpFormatSchema: () => FtpFormatSchema,
  FtpLongFormatProfileSchema: () => FtpLongFormatProfileSchema,
  FtpWideFormatProfileSchema: () => FtpWideFormatProfileSchema
});
import { z as z9 } from "zod";
var FtpFormatSchema = z9.enum(["willie-csv", "willie-ndjson", "adapter"]);
var adapterProfileBase = {
  delimiter: z9.string().min(1).default(";"),
  commentPrefix: z9.string().default("//"),
  skipRows: z9.number().int().nonnegative().default(0),
  decimalSeparator: z9.enum([",", "."]).default(","),
  timezone: z9.string().min(1).default("Europe/Paris"),
  dateFormat: z9.string().min(1)
};
var FtpLongFormatProfileSchema = z9.object({
  ...adapterProfileBase,
  layout: z9.literal("long").optional().default("long"),
  columns: z9.object({
    deviceID: z9.number().int().nonnegative(),
    timestamp: z9.number().int().nonnegative(),
    value: z9.number().int().nonnegative(),
    description: z9.number().int().nonnegative().optional()
  })
});
var FtpWideFormatProfileSchema = z9.object({
  ...adapterProfileBase,
  layout: z9.literal("wide"),
  columns: z9.object({
    date: z9.number().int().nonnegative(),
    /** Omit when `date` holds the whole timestamp; when set, `dateFormat`
     *  describes the date and time cells joined by a single space. */
    time: z9.number().int().nonnegative().optional(),
    firstValueColumn: z9.number().int().nonnegative()
  }).refine(
    ({ date, time, firstValueColumn }) => firstValueColumn > date && (time === void 0 || firstValueColumn > time),
    { message: "firstValueColumn must come after the date and time columns" }
  )
});
var FtpFormatProfileSchema = z9.discriminatedUnion("layout", [
  FtpLongFormatProfileSchema,
  FtpWideFormatProfileSchema
]);

// src/dynamic-metrics.ts
var dynamic_metrics_exports = {};
__export(dynamic_metrics_exports, {
  CreateDynamicMetricInputSchema: () => CreateDynamicMetricInputSchema,
  DEFAULT_METRIC_UNIT_LABEL: () => DEFAULT_METRIC_UNIT_LABEL,
  DEFAULT_PERIOD_REDUCER: () => DEFAULT_PERIOD_REDUCER,
  DEFAULT_PERIOD_REDUCER_ORDER: () => DEFAULT_PERIOD_REDUCER_ORDER,
  DynamicMetricASTSchema: () => DynamicMetricASTSchema,
  DynamicMetricCollectionsSchema: () => DynamicMetricCollectionsSchema,
  DynamicMetricReferenceKindSchema: () => DynamicMetricReferenceKindSchema,
  DynamicMetricReferenceSchema: () => DynamicMetricReferenceSchema,
  DynamicMetricReferencesSchema: () => DynamicMetricReferencesSchema,
  DynamicMetricSchema: () => DynamicMetricSchema,
  EvalWarningSchema: () => EvalWarningSchema,
  MetricCollectionEntrySchema: () => MetricCollectionEntrySchema,
  SHORT_ID_PATTERN: () => SHORT_ID_PATTERN,
  SHORT_ID_PATTERN_SOURCE: () => SHORT_ID_PATTERN_SOURCE,
  ShortIDSchema: () => ShortIDSchema,
  UpdateDynamicMetricInputSchema: () => UpdateDynamicMetricInputSchema,
  dbRowToDynamicMetric: () => dbRowToDynamicMetric,
  dynamicMetricToDbInsert: () => dynamicMetricToDbInsert,
  formulaFuncSchema: () => formulaFuncSchema,
  periodReducerOrderSchema: () => periodReducerOrderSchema,
  periodReducerSchema: () => periodReducerSchema,
  reduceSeries: () => reduceSeries
});
import * as _3 from "lodash-es";
import { z as z11 } from "zod";

// src/measurement-types.ts
import { z as z10 } from "zod";
var measurementTypeSchema = z10.enum(["water_volume", "water_level", "rainfall"]);
var temporalSemanticSchema = z10.enum(["additive", "spot"]);
var bucketAggregationSchema = z10.enum(["sum", "avg", "min", "max"]);
var measurementChartKindSchema = z10.enum(["consumption", "instantaneous", "rainfall"]);
var MEASUREMENT_TYPES = {
  water_volume: {
    temporalSemantic: "additive",
    defaultUnit: "m\xB3",
    allowedAggregations: ["sum"],
    allowedSourceTypes: ["meter", "manual", "metric", "api"],
    chartKind: "consumption"
  },
  water_level: {
    temporalSemantic: "spot",
    defaultUnit: "m",
    allowedAggregations: ["avg", "min", "max"],
    allowedSourceTypes: ["meter"],
    chartKind: "instantaneous"
  },
  rainfall: {
    temporalSemantic: "additive",
    defaultUnit: "mm",
    allowedAggregations: ["sum"],
    allowedSourceTypes: ["meter", "manual"],
    chartKind: "rainfall"
  }
};
var RAINY_DAY_THRESHOLD_MM = 1;
var getMeasurementTypeSpec = (measurementType) => MEASUREMENT_TYPES[measurementType];

// src/dynamic-metrics.ts
var DEFAULT_METRIC_UNIT_LABEL = MEASUREMENT_TYPES.water_volume.defaultUnit;
var SHORT_ID_PATTERN_SOURCE = "[a-z0-9]{8}";
var SHORT_ID_PATTERN = new RegExp(`^${SHORT_ID_PATTERN_SOURCE}$`);
var ShortIDSchema = z11.string().regex(SHORT_ID_PATTERN, "invalid short ID");
var formulaFuncSchema = z11.enum(["SUM", "AVG"]);
var periodReducerSchema = z11.enum(["SUM", "AVG", "MIN", "MAX", "FIRST", "LAST"]);
var DEFAULT_PERIOD_REDUCER = "SUM";
var PERIOD_REDUCERS = {
  SUM: _3.sum,
  AVG: _3.mean,
  MIN: _3.min,
  MAX: _3.max,
  FIRST: _3.head,
  LAST: _3.last
};
var reduceSeries = (values2, reducer) => {
  const present = values2.filter((v) => v !== null);
  if (present.length === 0) return null;
  return PERIOD_REDUCERS[reducer](present) ?? null;
};
var periodReducerOrderSchema = z11.enum(["reduce_first", "coalesce_first"]);
var DEFAULT_PERIOD_REDUCER_ORDER = "reduce_first";
var DynamicMetricASTSchema = z11.lazy(
  () => z11.discriminatedUnion("type", [
    z11.object({ type: z11.literal("number"), value: z11.number() }),
    z11.object({ type: z11.literal("station"), stationID: z11.string().uuid() }),
    z11.object({ type: z11.literal("collectionRef"), id: ShortIDSchema }),
    z11.object({
      type: z11.literal("aggregation"),
      func: formulaFuncSchema,
      operand: z11.object({ type: z11.literal("collectionRef"), id: ShortIDSchema })
    }),
    z11.object({
      type: z11.literal("binaryOp"),
      op: z11.enum(["+", "-", "*", "/"]),
      left: DynamicMetricASTSchema,
      right: DynamicMetricASTSchema
    })
  ])
);
var MetricCollectionEntrySchema = z11.object({
  name: z11.string().max(200).optional(),
  description: z11.string().max(1e3).optional(),
  rules: z11.array(collectionRuleSchema).min(1)
});
var DynamicMetricCollectionsSchema = z11.record(ShortIDSchema, MetricCollectionEntrySchema);
var DynamicMetricSchema = z11.object({
  id: z11.string().uuid(),
  createdAt: dateTimeSchema,
  orgID: z11.string().uuid(),
  siteID: z11.string().uuid().nullable(),
  groupID: z11.string().uuid().nullable(),
  name: z11.string().min(3).max(500),
  description: z11.string().max(1e3).optional(),
  unitLabel: z11.string().default(DEFAULT_METRIC_UNIT_LABEL),
  formula: z11.string().min(1),
  formulaAST: DynamicMetricASTSchema,
  collections: DynamicMetricCollectionsSchema,
  migratedFromMetricID: z11.string().uuid().nullable(),
  periodReducer: periodReducerSchema.default(DEFAULT_PERIOD_REDUCER),
  periodReducerOrder: periodReducerOrderSchema.default(DEFAULT_PERIOD_REDUCER_ORDER)
});
var StoredDynamicMetricSchema = DynamicMetricSchema.extend({
  periodReducer: periodReducerSchema.catch(DEFAULT_PERIOD_REDUCER),
  periodReducerOrder: periodReducerOrderSchema.catch(DEFAULT_PERIOD_REDUCER_ORDER)
});
var EvalWarningSchema = z11.discriminatedUnion("code", [
  z11.object({ code: z11.literal("empty_collection"), collectionName: z11.string() }),
  z11.object({ code: z11.literal("division_by_zero"), periodCount: z11.number().int() }),
  z11.object({ code: z11.literal("all_null") }),
  z11.object({
    code: z11.literal("missing_readings"),
    periodCount: z11.number().int(),
    totalPeriods: z11.number().int()
  }),
  z11.object({ code: z11.literal("circular_metric_reference"), stationIDs: z11.array(z11.string()) })
]);
var DynamicMetricReferenceKindSchema = z11.enum(["dashboard", "goal"]);
var DynamicMetricReferenceSchema = z11.object({
  kind: DynamicMetricReferenceKindSchema,
  id: z11.string().uuid(),
  name: z11.string()
});
var DynamicMetricReferencesSchema = z11.object({
  references: z11.array(DynamicMetricReferenceSchema)
});
var scopeRefine = (d) => d.siteID != null || d.groupID != null;
var DynamicMetricInputBase = DynamicMetricSchema.pick({
  name: true,
  description: true,
  unitLabel: true,
  formula: true,
  collections: true
}).extend({
  siteID: z11.string().uuid().nullable().optional(),
  groupID: z11.string().uuid().nullable().optional(),
  // Optional, not defaulted: an update that omits it keeps the stored reducer.
  periodReducer: periodReducerSchema.optional()
});
var CreateDynamicMetricInputSchema = DynamicMetricInputBase.refine(scopeRefine, {
  message: "At least one of siteID or groupID must be provided"
});
var UpdateDynamicMetricInputSchema = DynamicMetricInputBase.extend({
  id: z11.string().uuid()
}).refine(scopeRefine, { message: "At least one of siteID or groupID must be provided" });
var dbRowToDynamicMetric = (row) => StoredDynamicMetricSchema.parse({
  id: row.id,
  createdAt: row.created_at,
  orgID: row.org_id,
  siteID: row.site_id,
  groupID: row.group_id,
  name: row.name ?? "Unnamed",
  description: row.description ?? void 0,
  unitLabel: row.unit_label,
  formula: row.formula,
  formulaAST: row.formula_ast,
  collections: row.collections,
  migratedFromMetricID: row.migrated_from_metric_id,
  periodReducer: row.period_reducer,
  periodReducerOrder: row.period_reducer_order
});
var dynamicMetricToDbInsert = (input) => ({
  org_id: input.orgID,
  site_id: input.siteID ?? null,
  group_id: input.groupID ?? null,
  name: input.name,
  description: input.description ?? null,
  unit_label: input.unitLabel,
  formula: input.formula,
  formula_ast: input.formulaAST,
  collections: input.collections,
  period_reducer: input.periodReducer
});

// src/ops/index.ts
var ops_exports = {};
__export(ops_exports, {
  Contacts: () => contacts_exports,
  Freshdesk: () => freshdesk_exports,
  IndexCaptures: () => index_captures_exports,
  InstallationAttachments: () => installation_attachments_exports,
  InstallationProfileCatalog: () => installation_profile_catalog_exports,
  InstallationProfileSkus: () => installation_profile_skus_exports,
  InstallationProfiles: () => installation_profiles_exports,
  MaterialReturns: () => material_returns_exports,
  MeterMakers: () => meter_makers_exports,
  MeterPhotos: () => meter_photos_exports,
  StationInstallations: () => station_installations_exports
});

// src/ops/contacts.ts
var contacts_exports = {};
__export(contacts_exports, {
  contactFieldsSchema: () => contactFieldsSchema,
  contactIdSchema: () => contactIdSchema,
  createContactInputSchema: () => createContactInputSchema,
  listContactsInputSchema: () => listContactsInputSchema,
  updateContactInputSchema: () => updateContactInputSchema
});
import { z as z12 } from "zod";
var contactFieldsSchema = z12.object({
  name: z12.string().min(1),
  email: z12.string().email().nullish(),
  phone: z12.string().nullish(),
  address: z12.string().nullish()
});
var createContactInputSchema = contactFieldsSchema.extend({
  orgId: z12.string().uuid()
});
var updateContactInputSchema = contactFieldsSchema.partial().extend({
  contactId: z12.string().uuid()
});
var contactIdSchema = z12.object({
  contactId: z12.string().uuid()
});
var listContactsInputSchema = z12.object({
  orgId: z12.string().uuid().optional()
});

// src/ops/installation-profile-catalog.ts
var installation_profile_catalog_exports = {};
__export(installation_profile_catalog_exports, {
  installationProfileAttributesSchema: () => installationProfileAttributesSchema,
  installationProfileInputSchema: () => installationProfileInputSchema,
  profileLoggerMaker: () => profileLoggerMaker
});
import { z as z16 } from "zod";

// src/ops/installation-profiles.ts
var installation_profiles_exports = {};
__export(installation_profiles_exports, {
  INSTALLATION_PROFILE_SLUGS: () => INSTALLATION_PROFILE_SLUGS,
  hasInstallationGuide: () => hasInstallationGuide,
  installationProfileSchema: () => installationProfileSchema
});
import { z as z13 } from "zod";
var INSTALLATION_PROFILE_SLUGS = [
  "abb-few630",
  "abb-fxe4000",
  "b-meter-pl3",
  "b-meter-pl4",
  "cgr-5502",
  "cgr-5505",
  "cgr-5507",
  "cyble",
  "cyble-dock",
  "datalogger-only",
  "debimetre-eh",
  "debimetre-eh-ot-metric",
  "debimetre-eh-promag-30",
  "diehl-dock",
  "diehl-hydrus",
  "diehl-izar",
  "elster-pr6-v200",
  "fuji-modmag",
  "isma-dlk-102",
  "itron-aquadis",
  "itron-flodis",
  "itron-flostar",
  "itron-narval",
  "kamstrup-pulse-adapter",
  "krohne-ifc100",
  "krohne-ifc100-configured",
  "krohne-ifc100-copyconfig",
  "krohne-ifc100-otmetric",
  "maddalena-flowpulse-mvm",
  "maddalena-flowpulse-wmap-evo",
  "maddalena-reed-one",
  "maddalena-reed-sjplus",
  "maddalena-reed-wmap",
  "octave-arad",
  "ot-metric",
  "sensus-hri",
  "sensus-hri-mei",
  "siemens-fmt020",
  "siemens-mag-5000-6000",
  "zenner-edc-s",
  "zenner-mtk",
  "zenner-multipulse",
  "zenner-reed-woltman"
];
var hasInstallationGuide = (profile) => INSTALLATION_PROFILE_SLUGS.includes(profile);
var installationProfileSchema = z13.string().trim().min(1).max(60).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Use lowercase letters, numbers and hyphens");

// src/ops/meter-makers.ts
var meter_makers_exports = {};
__export(meter_makers_exports, {
  humanizeMeterMakerSlug: () => humanizeMeterMakerSlug,
  meterMakerInputSchema: () => meterMakerInputSchema,
  meterMakerLabelSchema: () => meterMakerLabelSchema,
  meterMakerSlugSchema: () => meterMakerSlugSchema,
  toMeterMakerSlug: () => toMeterMakerSlug
});
import { z as z14 } from "zod";
var meterMakerSlugSchema = z14.string().trim().min(1).max(60).regex(/^[a-z0-9]+(?:_[a-z0-9]+)*$/, "Use lowercase letters, numbers and underscores");
var meterMakerLabelSchema = z14.string().trim().min(1).max(80);
var meterMakerInputSchema = z14.object({
  slug: meterMakerSlugSchema,
  label: meterMakerLabelSchema
});
var toMeterMakerSlug = (label) => label.normalize("NFD").replace(/\p{Diacritic}/gu, "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
var humanizeMeterMakerSlug = (slug) => slug.split("_").filter((word) => word.length > 0).map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

// src/ops/station-installations.ts
var station_installations_exports = {};
__export(station_installations_exports, {
  BATCH_MAX_INSTALLATIONS: () => BATCH_MAX_INSTALLATIONS,
  BATCH_MAX_SITES: () => BATCH_MAX_SITES,
  FIRST_TRANSMISSION_WINDOW_DAYS: () => FIRST_TRANSMISSION_WINDOW_DAYS,
  INSTALLATION_EVENT_NOTE_MAX_LENGTH: () => INSTALLATION_EVENT_NOTE_MAX_LENGTH,
  INSTALLATION_GUIDE_BASE_URL: () => INSTALLATION_GUIDE_BASE_URL,
  INSTALL_APP_BASE_URL: () => INSTALL_APP_BASE_URL,
  MAX_SEARCH_ORG_IDS: () => MAX_SEARCH_ORG_IDS,
  ORDERABLE_COMPATIBILITY_STATUSES: () => ORDERABLE_COMPATIBILITY_STATUSES,
  PENDING_FILTER: () => PENDING_FILTER,
  addDataSourceInputSchema: () => addDataSourceInputSchema,
  assigneeDisplayName: () => assigneeDisplayName,
  batchCreateInputSchema: () => batchCreateInputSchema,
  batchInstallationSchema: () => batchInstallationSchema,
  batchSiteSchema: () => batchSiteSchema,
  buildCaptureUrl: () => buildCaptureUrl,
  buildIndexCaptureUrl: () => buildIndexCaptureUrl,
  buildInstallationGuideUrl: () => buildInstallationGuideUrl,
  buildMeterPhotosUrl: () => buildMeterPhotosUrl,
  compatibilityLockReason: () => compatibilityLockReason,
  compatibilityStatusSchema: () => compatibilityStatusSchema,
  compatibilityVerdictSchema: () => compatibilityVerdictSchema,
  confirmOrderInputSchema: () => confirmOrderInputSchema,
  createDataSourceInputSchema: () => createDataSourceInputSchema,
  createIndexReadingInputSchema: () => createIndexReadingInputSchema,
  createInputSchema: () => createInputSchema,
  createInstallationEventInputSchema: () => createInstallationEventInputSchema,
  dataSourceStatusSchema: () => dataSourceStatusSchema,
  detectModuleMaker: () => detectModuleMaker,
  dueForReminderInputSchema: () => dueForReminderInputSchema,
  hasCompatibilityVerdict: () => hasCompatibilityVerdict,
  hasKnownSerialFormat: () => hasKnownSerialFormat,
  installInputSchema: () => installInputSchema,
  installationBatchSourceSchema: () => installationBatchSourceSchema,
  installationEventTypeSchema: () => installationEventTypeSchema,
  installationIdSchema: () => installationIdSchema,
  isOrderableCompatibility: () => isOrderableCompatibility,
  listInputSchema: () => listInputSchema,
  loggerMakerSchema: () => loggerMakerSchema,
  meterCompatibilitySchema: () => meterCompatibilitySchema,
  normalizeName: () => normalizeName,
  orderableProviderSchema: () => orderableProviderSchema,
  preInstallationMonitoringSchema: () => preInstallationMonitoringSchema,
  reminderCandidateSchema: () => reminderCandidateSchema,
  resolveInstallationEventInputSchema: () => resolveInstallationEventInputSchema,
  retireInstallationInputSchema: () => retireInstallationInputSchema,
  setCompatibilityInputSchema: () => setCompatibilityInputSchema,
  shaypBuildingTypeSchema: () => shaypBuildingTypeSchema,
  stageSchema: () => stageSchema,
  stalledBecauseOfSchema: () => stalledBecauseOfSchema,
  stationTypeSchema: () => stationTypeSchema2,
  updatableFieldsSchema: () => updatableFieldsSchema,
  updateInputSchema: () => updateInputSchema,
  updateInstallationEventInputSchema: () => updateInstallationEventInputSchema
});
import { z as z15 } from "zod";
var meterCompatibilitySchema = z15.enum(["compatible", "in_analysis", "not_compatible"]);
var PENDING_FILTER = "pending";
var compatibilityStatusSchema = z15.enum([
  "pending",
  "in_analysis",
  "not_compatible",
  "compatible_supported",
  "compatible_approved",
  "compatible_not_supported"
]);
var stageSchema = z15.enum([
  "install_created",
  "image_received",
  "compatibility_checked",
  "order_placed",
  "hardware_shipped",
  "station_installed",
  "index_aligned"
]);
var loggerMakerSchema = z15.enum(["shayp", "efento", "adeunis", "other"]);
var preInstallationMonitoringSchema = z15.enum(["wired", "wireless", "not_monitored", "unknown"]);
var stationTypeSchema2 = z15.enum(["entry", "usage", "discharge"]);
var ORDERABLE_COMPATIBILITY_STATUSES = [
  "compatible_supported",
  "compatible_approved"
];
var isOrderableCompatibility = (status) => ORDERABLE_COMPATIBILITY_STATUSES.includes(status);
var hasCompatibilityVerdict = (status) => status !== "pending" && status !== "in_analysis";
var MODULE_SERIAL_PATTERN_BY_MAKER = {
  shayp: /^N[0-9A-Z]{7,8}$/,
  efento: /^[0-9A-F]{12}$/
};
var MODULE_SERIAL_PATTERNS = Object.entries(MODULE_SERIAL_PATTERN_BY_MAKER);
var detectModuleMaker = (serial) => MODULE_SERIAL_PATTERNS.find(([, pattern]) => pattern.test(serial))?.[0] ?? null;
var hasKnownSerialFormat = (maker) => maker !== null && maker in MODULE_SERIAL_PATTERN_BY_MAKER;
var updatableFieldsSchema = z15.object({
  name: z15.string().nullish(),
  internalId: z15.string().nullish(),
  siteContactId: z15.string().uuid().nullish(),
  installationContactId: z15.string().uuid().nullish(),
  meterMaker: meterMakerSlugSchema.nullish(),
  meterModel: z15.string().nullish(),
  loggerSerialNumber: z15.string().nullish(),
  pulseWeight: z15.number().positive().nullish(),
  preInstallationMonitoring: preInstallationMonitoringSchema.nullish(),
  orderPlacedDate: z15.string().date().nullish(),
  instructionSentDate: z15.string().date().nullish(),
  loggerShippingDate: z15.string().date().nullish(),
  installationDate: z15.string().date().nullish(),
  plannedInstallationDate: z15.string().date().nullish(),
  indexAlignedDate: z15.string().date().nullish(),
  kickoffDate: z15.string().date().nullish(),
  installationReminderDate: z15.string().date().nullish(),
  retiredAt: z15.string().date().nullish(),
  retirementReason: z15.string().nullish(),
  // Not `.url()`: new writes store a bare `ops` bucket path, while existing rows hold
  // an absolute URL — either a legacy public one of ours or a third-party project's.
  preInstallationImageUrl: z15.string().nullish(),
  preInstallationImageAddedAt: z15.string().date().nullish()
});
var createInputSchema = updatableFieldsSchema.extend({
  orgId: z15.string().uuid(),
  siteId: z15.string().uuid(),
  stationType: stationTypeSchema2,
  // Names the station too, which is created first — so unlike on `update`, it cannot be blank.
  name: z15.string().min(1)
});
var updateInputSchema = updatableFieldsSchema.partial().extend({
  installationId: z15.number().int().positive()
});
var FIRST_TRANSMISSION_WINDOW_DAYS = 30;
var MAX_SEARCH_ORG_IDS = 10;
var listInputSchema = z15.object({
  orgId: z15.string().uuid().optional(),
  siteId: z15.string().uuid().optional(),
  stage: stageSchema.optional(),
  compatibilityStatus: compatibilityStatusSchema.optional(),
  meterMaker: meterMakerSlugSchema.optional(),
  loggerMaker: loggerMakerSchema.optional(),
  preInstallationMonitoring: preInstallationMonitoringSchema.optional(),
  installationProfile: installationProfileSchema.optional(),
  search: z15.string().optional(),
  // Widens `search` to the installations of these orgs; unlike `orgId`, it does not narrow.
  searchOrgIds: z15.array(z15.string().uuid()).min(1).max(MAX_SEARCH_ORG_IDS).optional(),
  installationIds: z15.array(z15.number().int().positive()).optional(),
  includeRetired: z15.boolean().optional()
});
var installationIdSchema = z15.object({
  installationId: z15.number().int().positive()
});
var compatibilityVerdictSchema = z15.discriminatedUnion("outcome", [
  z15.object({ outcome: z15.literal("in_analysis") }),
  z15.object({ outcome: z15.literal("not_compatible") }),
  z15.object({ outcome: z15.literal("compatible"), installationProfile: installationProfileSchema })
]);
var setCompatibilityInputSchema = z15.object({
  installationId: z15.number().int().positive(),
  verdict: compatibilityVerdictSchema,
  meterMaker: meterMakerSlugSchema.nullish(),
  meterModel: z15.string().nullish()
});
var compatibilityLockReason = (row) => {
  if (row.retired_at) return "This installation is retired.";
  if (row.order_placed_date) return "Locked once the order is placed.";
  if (!row.pre_installation_image_added_at) return "Needs the pre-installation image first.";
  return null;
};
var INSTALLATION_GUIDE_BASE_URL = "https://docs.meetwillie.com/installation-guides";
var buildInstallationGuideUrl = (profile, installationId) => `${INSTALLATION_GUIDE_BASE_URL}/${profile}?installationId=${encodeURIComponent(String(installationId))}`;
var INSTALL_APP_BASE_URL = "https://install.meetwillie.com";
var tokenLink = (baseUrl, path, token) => `${baseUrl.replace(/\/+$/, "")}/${path}#t=${encodeURIComponent(token)}`;
var buildCaptureUrl = (baseUrl, token, installationId) => {
  const base = tokenLink(baseUrl, "capture", token);
  return installationId === null ? base : `${base}&i=${encodeURIComponent(String(installationId))}`;
};
var buildMeterPhotosUrl = (baseUrl, token) => tokenLink(baseUrl, "photos", token);
var buildIndexCaptureUrl = (baseUrl, token) => tokenLink(baseUrl, "index-capture", token);
var BATCH_MAX_SITES = 25;
var BATCH_MAX_INSTALLATIONS = 250;
var installationBatchSourceSchema = z15.enum(["csv", "batchBuilder", "station"]);
var newStationSchema = z15.object({
  mode: z15.literal("create"),
  name: z15.string().min(1),
  stationType: stationTypeSchema2,
  internalId: z15.string().min(1).nullish()
});
var existingStationSchema = z15.object({
  mode: z15.literal("adopt"),
  waterStationId: z15.string().uuid()
});
var batchInstallationSchema = z15.object({
  station: z15.discriminatedUnion("mode", [newStationSchema, existingStationSchema]),
  pictureFromClientRequired: z15.boolean()
});
var batchSiteSchema = z15.object({
  siteId: z15.string().uuid().nullable(),
  siteName: z15.string().min(1),
  // Whoever takes delivery is a property of the place, not of each meter in it.
  siteContactId: z15.string().uuid().nullish(),
  installationContactId: z15.string().uuid().nullish(),
  installations: z15.array(batchInstallationSchema).min(1).max(BATCH_MAX_INSTALLATIONS)
}).refine(
  (site) => site.siteId !== null || Boolean(site.siteContactId),
  (site) => ({ path: ["siteContactId"], message: `${site.siteName} is a new site and needs a contact` })
);
var normalizeName = (name) => name.trim().replace(/\s+/g, " ").toLowerCase();
var batchSiteKey = (site) => site.siteId ?? `new:${normalizeName(site.siteName)}`;
var batchCreateInputSchema = z15.object({
  orgId: z15.string().uuid(),
  source: installationBatchSourceSchema,
  // One batch is one engagement, so these are asked once rather than repeated per installation.
  kickoffDate: z15.string().date().nullish(),
  plannedInstallationDate: z15.string().date().nullish(),
  sites: z15.array(batchSiteSchema).min(1).max(BATCH_MAX_SITES)
}).superRefine((input, ctx) => {
  const total = input.sites.reduce((sum2, site) => sum2 + site.installations.length, 0);
  if (total > BATCH_MAX_INSTALLATIONS) {
    ctx.addIssue({
      code: z15.ZodIssueCode.custom,
      path: ["sites"],
      message: `A batch holds at most ${BATCH_MAX_INSTALLATIONS} installations, this one has ${total}`
    });
  }
  const seen = /* @__PURE__ */ new Set();
  input.sites.forEach((site, index) => {
    const key = batchSiteKey(site);
    if (seen.has(key)) {
      ctx.addIssue({
        code: z15.ZodIssueCode.custom,
        path: ["sites", index, "siteName"],
        message: `Site appears more than once: ${site.siteName}`
      });
    }
    seen.add(key);
  });
});
var readingMethodSchema = z15.enum(["incremental", "cumulative"]);
var measurementUnitSchema = z15.enum(["l", "m3"]);
var createIndexReadingInputSchema = z15.object({
  value: z15.number().min(0),
  readingAt: z15.string().datetime({ offset: true }).refine((iso) => new Date(iso) <= /* @__PURE__ */ new Date(), { message: "Index reading cannot be in the future" })
});
var shaypBuildingTypeSchema = z15.enum([
  "LIVING_HOUSEHOLD",
  "LIVING_APT_BUILD",
  "LIVING_STU_BUILD",
  "LIVING_HOSTING_SMALL",
  "LIVING_HOSTING_LARGE",
  "LIVING_HOSPITAL",
  "LIVING_NURSING",
  "WORK_OFFICES",
  "WORK_SCHOOL",
  "WORK_PUBLIC",
  "FACILITY_SWIMM",
  "FACILITY_SPORT",
  "FACILITY_OTHER",
  "INFRA",
  "FOUNTAIN",
  "HIGHWAY_GAS_STATION",
  "OTHER"
]);
var createDataSourceInputSchema = z15.discriminatedUnion("maker", [
  z15.object({
    maker: z15.literal("shayp"),
    // The meter's device code (Shayp's `device` field). We POST it to Shayp's
    // /admin/installations/ endpoint to provision the device, then resolve the
    // device UUID (device.id) by this serial to store in the data source config.
    serialNumber: z15.string().min(1),
    pulseWeight: z15.number().positive().default(1),
    buildingType: shaypBuildingTypeSchema.default("OTHER"),
    // Optional Shayp device description. When omitted, the server auto-generates
    // `orgName_SiteName_StationName`.
    deviceDescription: z15.string().optional(),
    // Optional initial index for the Shayp installation; defaults to 1 / now server-side.
    index: createIndexReadingInputSchema.optional(),
    readingMethod: readingMethodSchema.default("incremental"),
    unit: measurementUnitSchema.default("l")
  }),
  z15.object({
    maker: z15.literal("adeunis"),
    deviceID: z15.string().min(1),
    channel: z15.enum(["A", "B"]),
    pulseWeight: z15.number().nonnegative().default(0),
    readingMethod: readingMethodSchema.default("cumulative"),
    unit: measurementUnitSchema.default("l")
  }),
  z15.object({
    maker: z15.literal("efento"),
    deviceID: z15.string().min(1),
    channel: z15.number().int().positive(),
    pulseWeight: z15.number().positive().default(1),
    readingMethod: readingMethodSchema.default("incremental"),
    unit: measurementUnitSchema.default("l")
  })
]);
var installInputSchema = z15.object({
  installationId: z15.number().int().positive(),
  index: createIndexReadingInputSchema.nullable().default(null),
  dataSource: createDataSourceInputSchema.nullable().default(null)
});
var addDataSourceInputSchema = z15.object({
  installationId: z15.number().int().positive(),
  dataSource: createDataSourceInputSchema
});
var dataSourceStatusSchema = z15.enum([
  "created",
  "device-not-found",
  "no-shayp-connection",
  "not-requested",
  "error"
]);
var INSTALLATION_EVENT_NOTE_MAX_LENGTH = 5e3;
var retireInstallationInputSchema = z15.object({
  installationId: z15.number().int().positive(),
  reason: z15.string().min(1).max(INSTALLATION_EVENT_NOTE_MAX_LENGTH)
});
var stalledBecauseOfSchema = z15.enum(["client", "logger_provider", "willie", "other"]);
var installationEventTypeSchema = z15.enum([
  "stalled",
  "reminder_sent",
  "guide_opened",
  "help_requested",
  "serial_mismatch",
  "install_submitted",
  "module_assigned",
  "install_verification_reported",
  "outbound_email",
  "index_capture_requested",
  "index_capture_received",
  "index_capture_decided",
  "index_aligned",
  "retired",
  "transactional_sent",
  "material_return_sent",
  "material_return_received",
  "compatibility_confirmed",
  "unsupported_profile_approved"
]);
var assigneeDisplayName = (assignee) => assignee.assignedToName ?? assignee.assignedToEmail;
var createInstallationEventInputSchema = z15.object({
  installationId: z15.number().int().positive(),
  type: installationEventTypeSchema,
  note: z15.string().min(1).max(INSTALLATION_EVENT_NOTE_MAX_LENGTH),
  category: stalledBecauseOfSchema,
  assignedToUserId: z15.string().uuid().nullable().optional()
});
var resolveInstallationEventInputSchema = z15.object({
  eventId: z15.number().int().positive()
});
var updateInstallationEventInputSchema = z15.object({
  eventId: z15.number().int().positive(),
  note: z15.string().min(1).max(INSTALLATION_EVENT_NOTE_MAX_LENGTH),
  category: stalledBecauseOfSchema,
  assignedToUserId: z15.string().uuid().nullable().optional()
});
var orderableProviderSchema = z15.enum(["shayp", "efento"]);
var confirmOrderInputSchema = z15.object({
  provider: orderableProviderSchema,
  filename: z15.string().min(1),
  csv: z15.string().min(1),
  installationIds: z15.array(z15.number().int().positive()).min(1).max(500)
});
var dueForReminderInputSchema = z15.object({
  stalePlannedDays: z15.number().int().positive().default(10),
  staleShippedDays: z15.number().int().positive().default(10)
});
var reminderCandidateSchema = z15.object({
  installationId: z15.number().int().positive(),
  installationReminderDate: z15.string().nullable(),
  remindersSent: z15.number().int().nonnegative(),
  stalled: z15.boolean()
});

// src/ops/installation-profile-catalog.ts
var installationProfileAttributesSchema = z16.object({
  meterMakers: z16.array(meterMakerSlugSchema),
  meterModels: z16.array(z16.string().trim().min(1)),
  loggerMakers: z16.array(loggerMakerSchema),
  supported: z16.boolean()
});
var installationProfileInputSchema = installationProfileAttributesSchema.extend({
  slug: installationProfileSchema
});
var profileLoggerMaker = (loggerMakers) => loggerMakerSchema.safeParse(loggerMakers[0]).data ?? null;

// src/ops/meter-photos.ts
var meter_photos_exports = {};
__export(meter_photos_exports, {
  MAX_FILES_PER_CALL: () => MAX_FILES_PER_CALL,
  addMeterPhotosInputSchema: () => addMeterPhotosInputSchema,
  addMeterPhotosOutputSchema: () => addMeterPhotosOutputSchema,
  suggestedCompatibilitySchema: () => suggestedCompatibilitySchema
});
import { z as z18 } from "zod";

// src/ops/installation-attachments.ts
var installation_attachments_exports = {};
__export(installation_attachments_exports, {
  ACCEPTED_PHOTO_TYPES: () => ACCEPTED_PHOTO_TYPES,
  MAX_PHOTO_BYTES: () => MAX_PHOTO_BYTES,
  attachmentKindSchema: () => attachmentKindSchema,
  attachmentPath: () => attachmentPath,
  captureKindSchema: () => captureKindSchema,
  classifyFile: () => classifyFile,
  photoRejectionReasonSchema: () => photoRejectionReasonSchema,
  photoTypeForPath: () => photoTypeForPath
});
import { z as z17 } from "zod";
var captureKindSchema = z17.enum(["meter_index", "module_id", "wide_shot", "step_photo"]);
var attachmentKindSchema = z17.enum([...captureKindSchema.options, "meter_photo"]);
var ACCEPTED_PHOTO_TYPES = ["image/jpeg", "image/png", "image/webp"];
var EXTENSION_BY_PHOTO_TYPE = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp"
};
var MAX_PHOTO_BYTES = 3.75 * 1024 * 1024;
var photoRejectionReasonSchema = z17.enum(["unsupported-format", "too-large"]);
var isAcceptedPhotoType = (contentType) => ACCEPTED_PHOTO_TYPES.includes(contentType);
var classifyFile = (file) => {
  if (!isAcceptedPhotoType(file.contentType)) return { reason: "unsupported-format" };
  if (file.size > MAX_PHOTO_BYTES) return { reason: "too-large" };
  return { contentType: file.contentType };
};
var photoTypeForPath = (storagePath) => {
  const extension = (storagePath.split(".").pop() ?? "").toLowerCase();
  if (extension === "jpeg") return "image/jpeg";
  return ACCEPTED_PHOTO_TYPES.find((type) => EXTENSION_BY_PHOTO_TYPE[type] === extension) ?? null;
};
var attachmentPath = (installationId, kind, fileId, contentType) => `installations/${installationId}/capture/${kind}-${fileId}.${EXTENSION_BY_PHOTO_TYPE[contentType]}`;

// src/ops/meter-photos.ts
var MAX_FILES_PER_CALL = 20;
var suggestedCompatibilitySchema = z18.enum([
  ...meterCompatibilitySchema.exclude(["in_analysis"]).options,
  "unsure"
]);
var filenameSchema = z18.string().trim().min(1).max(255);
var addMeterPhotosInputSchema = z18.object({
  installationId: z18.number().int().positive(),
  receivedFrom: z18.string().trim().max(320).optional(),
  files: z18.array(z18.object({ filename: filenameSchema, contentType: z18.string().min(1), data: z18.instanceof(Uint8Array) })).min(1).max(MAX_FILES_PER_CALL)
});
var addMeterPhotosOutputSchema = z18.object({
  added: z18.array(z18.object({ photoId: z18.string().uuid(), filename: z18.string() })),
  rejected: z18.array(z18.object({ filename: z18.string(), reason: photoRejectionReasonSchema }))
});

// src/ops/installation-profile-skus.ts
var installation_profile_skus_exports = {};
__export(installation_profile_skus_exports, {
  ASSEMBLY_PROFILE_SKUS: () => ASSEMBLY_PROFILE_SKUS,
  INSTALLATION_PROFILE_ASSEMBLY_PROFILE: () => INSTALLATION_PROFILE_ASSEMBLY_PROFILE,
  SKU_CATALOG: () => SKU_CATALOG,
  assemblyProfileBom: () => assemblyProfileBom,
  assemblyProfileSkuLines: () => assemblyProfileSkuLines,
  customerBom: () => customerBom,
  installationProfileAssemblyProfile: () => installationProfileAssemblyProfile,
  installationProfileSkus: () => installationProfileSkus,
  supplierArticle: () => supplierArticle,
  supplierBom: () => supplierBom
});
import { countBy } from "lodash-es";
var PULSE_SENSOR = "Capteur d'impulsions";
var MOUNT = "Support de fixation";
var COMMUNICATION_MODULE = "Module de communication Willie";
var PULSE_DUPLICATOR = "Duplicateur d'impulsion";
var WATERPROOF_CONNECTOR = "Connecteur \xE9tanche";
var SKU_CATALOG = {
  "Data Logger Efento NB-IoT": { clientLabel: COMMUNICATION_MODULE, articleCode: "Data Logger Efento NB-IoT" },
  "Diehl Izar BE Pulse": { clientLabel: MOUNT, articleCode: null },
  "B-Meter PL3": { clientLabel: PULSE_SENSOR, articleCode: "BME-1749060-10" },
  "B-Meter PL4": { clientLabel: PULSE_SENSOR, articleCode: "BME-1749063" },
  "CGR-5502": { clientLabel: PULSE_SENSOR, articleCode: "CGR-EI5502" },
  "CGR-5505": { clientLabel: PULSE_SENSOR, articleCode: "CGR-EI5505" },
  "CGR-5507": { clientLabel: PULSE_SENSOR, articleCode: "CGR-EI5507" },
  "Diehl Izar Pulse I": { clientLabel: PULSE_SENSOR, articleCode: "DIE-IZAR-PULSE-I-K1" },
  "ITRON Cyble Sensor V2 - 2 fils K=1": { clientLabel: PULSE_SENSOR, articleCode: "ITR-CYBLE42K1" },
  "ITRON Cyble Dock V2 Kit": { clientLabel: PULSE_SENSOR, articleCode: "CYBLEDOCKV2KIT" },
  "Maddalena - EI SJ/SD PLUS": { clientLabel: PULSE_SENSOR, articleCode: "MAD-2749030" },
  "Maddalena - FlowPulse": { clientLabel: PULSE_SENSOR, articleCode: "MAD-2749062" },
  "Maddalena Reed One": { clientLabel: PULSE_SENSOR, articleCode: "MAD-2749031" },
  "Maddalena Reed WMAP": { clientLabel: PULSE_SENSOR, articleCode: "MAD-9821017" },
  "OTMetric - Duo Pulse FXP2": { clientLabel: PULSE_DUPLICATOR, articleCode: "OTM-DUO_PULSE_FXP2" },
  "Connecteur \xE9tanche IP68": { clientLabel: WATERPROOF_CONNECTOR, articleCode: "3686306" }
};
var supplierArticle = (sku) => SKU_CATALOG[sku].articleCode;
var ASSEMBLY_PROFILE_SKUS = {
  "logger-only": ["Data Logger Efento NB-IoT"],
  "b-meter-pl3": ["B-Meter PL3", "Data Logger Efento NB-IoT"],
  "b-meter-pl4": ["B-Meter PL4", "Data Logger Efento NB-IoT"],
  "cgr-5502": ["CGR-5502", "Data Logger Efento NB-IoT"],
  "cgr-5505": ["CGR-5505", "Data Logger Efento NB-IoT"],
  "cgr-5507": ["CGR-5507", "Data Logger Efento NB-IoT"],
  "itron-cyble": ["ITRON Cyble Sensor V2 - 2 fils K=1", "Data Logger Efento NB-IoT"],
  "cyble-dock": ["ITRON Cyble Dock V2 Kit", "Data Logger Efento NB-IoT"],
  "diehl-dock": ["Diehl Izar BE Pulse", "Diehl Izar Pulse I", "Data Logger Efento NB-IoT"],
  "diehl-izar": ["Diehl Izar Pulse I", "Data Logger Efento NB-IoT"],
  "maddalena-flowpulse": ["Maddalena - FlowPulse", "Data Logger Efento NB-IoT"],
  "maddalena-reed-one": ["Maddalena Reed One", "Data Logger Efento NB-IoT"],
  "maddalena-reed-sjplus": ["Maddalena - EI SJ/SD PLUS", "Data Logger Efento NB-IoT"],
  "maddalena-reed-wmap": ["Maddalena Reed WMAP", "Data Logger Efento NB-IoT"],
  "ot-metric": [
    "OTMetric - Duo Pulse FXP2",
    "Connecteur \xE9tanche IP68",
    "Connecteur \xE9tanche IP68",
    "Data Logger Efento NB-IoT"
  ]
};
var INSTALLATION_PROFILE_ASSEMBLY_PROFILE = {
  "abb-few630": "logger-only",
  "abb-fxe4000": "logger-only",
  "b-meter-pl3": "b-meter-pl3",
  "b-meter-pl4": "b-meter-pl4",
  "cgr-5502": "cgr-5502",
  "cgr-5505": "cgr-5505",
  "cgr-5507": "cgr-5507",
  cyble: "itron-cyble",
  "cyble-dock": "cyble-dock",
  "datalogger-only": "logger-only",
  "debimetre-eh": "logger-only",
  "debimetre-eh-ot-metric": "ot-metric",
  "debimetre-eh-promag-30": "logger-only",
  "diehl-dock": "diehl-dock",
  "diehl-hydrus": "logger-only",
  "diehl-izar": "diehl-izar",
  "fuji-modmag": "logger-only",
  "isma-dlk-102": "logger-only",
  "itron-aquadis": "itron-cyble",
  "itron-flodis": "itron-cyble",
  "itron-flostar": "itron-cyble",
  "itron-narval": "itron-cyble",
  "krohne-ifc100": "logger-only",
  "krohne-ifc100-configured": "logger-only",
  "krohne-ifc100-copyconfig": "logger-only",
  "krohne-ifc100-otmetric": "ot-metric",
  "maddalena-flowpulse-mvm": "maddalena-flowpulse",
  "maddalena-flowpulse-wmap-evo": "maddalena-flowpulse",
  "maddalena-reed-one": "maddalena-reed-one",
  "maddalena-reed-sjplus": "maddalena-reed-sjplus",
  "maddalena-reed-wmap": "maddalena-reed-wmap",
  "ot-metric": "ot-metric",
  "siemens-fmt020": "logger-only",
  "siemens-mag-5000-6000": "logger-only",
  "zenner-mtk": "logger-only",
  "zenner-multipulse": "logger-only"
};
var installationProfileAssemblyProfile = (profile) => {
  if (!profile) return null;
  const assemblyProfile = INSTALLATION_PROFILE_ASSEMBLY_PROFILE[profile];
  return assemblyProfile ?? null;
};
var installationProfileSkus = (profile) => {
  const assemblyProfile = installationProfileAssemblyProfile(profile);
  return assemblyProfile ? ASSEMBLY_PROFILE_SKUS[assemblyProfile] : null;
};
var skusFor = (profiles) => profiles.flatMap((profile) => installationProfileSkus(profile) ?? []);
var countLines = (skus, labelOf) => Object.entries(countBy(skus, labelOf)).map(([label, quantity]) => ({ label, quantity }));
var supplierBom = (profiles) => countLines(skusFor(profiles), (sku) => supplierArticle(sku) ?? sku);
var customerBom = (profiles) => countLines(skusFor(profiles), (sku) => SKU_CATALOG[sku].clientLabel);
var assemblyProfileSkuLines = (assemblyProfile) => {
  const skus = ASSEMBLY_PROFILE_SKUS[assemblyProfile];
  return [...new Set(skus)].map((sku) => ({
    sku,
    quantity: skus.filter((candidate) => candidate === sku).length,
    ...SKU_CATALOG[sku]
  }));
};
var assemblyProfileBom = (assemblyProfile) => assemblyProfileSkuLines(assemblyProfile).map(({ sku, quantity }) => ({ label: sku, quantity }));

// src/ops/freshdesk.ts
var freshdesk_exports = {};
__export(freshdesk_exports, {
  OPEN_WORK_STATUSES: () => OPEN_WORK_STATUSES,
  TICKET_PRIORITY_LABELS: () => TICKET_PRIORITY_LABELS,
  TICKET_SOURCE_LABELS: () => TICKET_SOURCE_LABELS,
  TICKET_STATUS_LABELS: () => TICKET_STATUS_LABELS,
  createTicketInputSchema: () => createTicketInputSchema,
  installationTicketsSchema: () => installationTicketsSchema,
  isOpenStatus: () => isOpenStatus,
  openTicketCountsSchema: () => openTicketCountsSchema,
  openTicketSchema: () => openTicketSchema,
  ticketLinkSchema: () => ticketLinkSchema,
  ticketPriorityLabel: () => ticketPriorityLabel,
  ticketSourceLabel: () => ticketSourceLabel,
  ticketStatusLabel: () => ticketStatusLabel
});
import { z as z19 } from "zod";
var TICKET_STATUS_LABELS = {
  2: "Open",
  3: "Pending",
  4: "Resolved",
  5: "Closed"
};
var CLOSED_STATUSES = /* @__PURE__ */ new Set([4, 5]);
var OPEN_WORK_STATUSES = [2, 3];
var isOpenStatus = (status) => !CLOSED_STATUSES.has(status);
var ticketStatusLabel = (status) => TICKET_STATUS_LABELS[status] ?? `Status ${status}`;
var TICKET_SOURCE_LABELS = {
  1: "Inbound Email",
  2: "Portal",
  3: "Phone",
  4: "Forum",
  8: "MobiHelp",
  9: "Feedback Widget",
  10: "Outbound Email",
  11: "Ecommerce",
  13: "Whatsapp",
  15: "Web Chat",
  16: "Web Form",
  17: "Instagram Message",
  18: "Instagram Comment",
  19: "Facebook Message",
  20: "Facebook Comment",
  21: "Mobile Chat SDK",
  22: "SMS"
};
var ticketSourceLabel = (source) => TICKET_SOURCE_LABELS[source] ?? `Source ${source}`;
var TICKET_PRIORITY_LABELS = {
  1: "Low",
  2: "Medium",
  3: "High",
  4: "Urgent"
};
var ticketPriorityLabel = (priority) => TICKET_PRIORITY_LABELS[priority] ?? `Priority ${priority}`;
var ticketLinkSchema = z19.object({
  id: z19.number(),
  subject: z19.string(),
  status: z19.number(),
  statusLabel: z19.string(),
  isOpen: z19.boolean(),
  source: z19.number(),
  sourceLabel: z19.string(),
  createdAt: z19.string(),
  updatedAt: z19.string(),
  url: z19.string()
});
var installationTicketsSchema = z19.object({
  configured: z19.boolean(),
  tickets: z19.array(ticketLinkSchema)
});
var openTicketSchema = ticketLinkSchema.extend({
  installationId: z19.string()
});
var openTicketCountsSchema = z19.object({
  configured: z19.boolean(),
  byInstallationId: z19.record(z19.string(), z19.number()),
  tickets: z19.array(openTicketSchema)
});
var createTicketInputSchema = z19.object({
  installationId: z19.number().int().positive(),
  requesterEmail: z19.string().email(),
  requesterName: z19.string().min(1).optional(),
  subject: z19.string().min(1).max(255),
  body: z19.string().min(1),
  priority: z19.number().int().min(1).max(4)
});

// src/ops/index-captures.ts
var index_captures_exports = {};
__export(index_captures_exports, {
  AWAITING_VERDICT_CAPTURE_STATUSES: () => AWAITING_VERDICT_CAPTURE_STATUSES,
  FINAL_ROUND: () => FINAL_ROUND,
  IN_FLIGHT_CAPTURE_STATUSES: () => IN_FLIGHT_CAPTURE_STATUSES,
  OPEN_CAPTURE_STATUSES: () => OPEN_CAPTURE_STATUSES,
  captureDecisionSchema: () => captureDecisionSchema,
  captureOutcomeSchema: () => captureOutcomeSchema,
  captureStatusSchema: () => captureStatusSchema,
  ineligibleReasonSchema: () => ineligibleReasonSchema,
  isAwaitingVerdict: () => isAwaitingVerdict
});
import { z as z20 } from "zod";
var captureStatusSchema = z20.enum(["pending", "sent", "captured", "matched", "flagged", "resolved"]);
var captureOutcomeSchema = z20.enum([
  "match",
  "mismatch",
  "no_movement",
  "decreasing",
  "no_reading",
  "no_telemetry",
  "cannot_verify"
]);
var ineligibleReasonSchema = z20.enum([
  "no-station",
  "no-anchor",
  "no-gate",
  "no-telemetry",
  "not-spanning"
]);
var IN_FLIGHT_CAPTURE_STATUSES = ["pending", "sent"];
var AWAITING_VERDICT_CAPTURE_STATUSES = ["captured", "flagged"];
var isAwaitingVerdict = (status) => AWAITING_VERDICT_CAPTURE_STATUSES.includes(status);
var OPEN_CAPTURE_STATUSES = [...IN_FLIGHT_CAPTURE_STATUSES, "captured"];
var captureDecisionSchema = z20.enum(["aligned", "not_aligned"]);
var FINAL_ROUND = 2;

// src/ops/material-returns.ts
var material_returns_exports = {};
__export(material_returns_exports, {
  MATERIAL_DESCRIPTION_MAX_LENGTH: () => MATERIAL_DESCRIPTION_MAX_LENGTH,
  createMaterialReturnInputSchema: () => createMaterialReturnInputSchema,
  listMaterialReturnsForInstallationInputSchema: () => listMaterialReturnsForInstallationInputSchema,
  listMaterialReturnsInputSchema: () => listMaterialReturnsInputSchema,
  materialReturnIdInputSchema: () => materialReturnIdInputSchema,
  materialReturnProviderSchema: () => materialReturnProviderSchema,
  materialReturnStatusSchema: () => materialReturnStatusSchema
});
import { z as z21 } from "zod";
var materialReturnProviderSchema = loggerMakerSchema.extract(["shayp"]);
var MATERIAL_DESCRIPTION_MAX_LENGTH = 1e3;
var createMaterialReturnInputSchema = z21.object({
  orgId: z21.string().uuid(),
  provider: materialReturnProviderSchema,
  installationIds: z21.array(z21.number().int().positive()).min(1),
  contactId: z21.string().uuid(),
  ccEmail: z21.string().trim().email().nullish(),
  materialDescription: z21.string().trim().min(1).max(MATERIAL_DESCRIPTION_MAX_LENGTH),
  labelStoragePath: z21.string().regex(/^returns\/[^/]+\/label\.pdf$/),
  trackingNumber: z21.string().transform((value) => value.replace(/\s/g, "")).pipe(z21.string().regex(/^\d{10}$/, "A DHL waybill number is 10 digits"))
});
var materialReturnIdInputSchema = z21.object({ id: z21.string().uuid() });
var listMaterialReturnsForInstallationInputSchema = z21.object({
  installationId: z21.number().int().positive()
});
var materialReturnStatusSchema = z21.enum(["in_progress", "received"]);
var listMaterialReturnsInputSchema = z21.object({
  status: materialReturnStatusSchema.optional()
});

// src/leak-v0.ts
var leak_v0_exports = {};
__export(leak_v0_exports, {
  UNPINNED_PARAMS_HASH: () => UNPINNED_PARAMS_HASH,
  adjudicationAutoSchema: () => adjudicationAutoSchema,
  adjudicationManualSchema: () => adjudicationManualSchema,
  floorReferenceSchema: () => floorReferenceSchema,
  leakEpisodeEventSchema: () => leakEpisodeEventSchema,
  leakEpisodeStateSchema: () => leakEpisodeStateSchema,
  leakProviderSchema: () => leakProviderSchema,
  openLeakEpisodeStates: () => openLeakEpisodeStates,
  qualityFlagSchema: () => qualityFlagSchema,
  sourceSchema: () => sourceSchema
});
import { z as z22 } from "zod";
var leakProviderSchema = z22.enum(["shayp", "willie"]);
var leakEpisodeStateSchema = z22.enum(["OFF", "CANDIDATE", "CONFIRMED", "PENDING_CLEAR", "CLEAR"]);
var openLeakEpisodeStates = ["CANDIDATE", "CONFIRMED", "PENDING_CLEAR"];
var floorReferenceSchema = z22.enum(["zero_floor", "base_load"]);
var adjudicationAutoSchema = z22.enum(["agrees_with_shayp", "disagrees_with_shayp", "no_shayp_data"]);
var adjudicationManualSchema = z22.enum(["true_leak", "false_positive", "unknown"]);
var UNPINNED_PARAMS_HASH = "unpinned";
var sourceSchema = z22.enum(["live", "backfill"]);
var qualityFlagSchema = z22.enum(["valid", "gap", "suspect"]);
var leakEpisodeEventSchema = z22.object({
  fromState: leakEpisodeStateSchema.nullable(),
  toState: z22.union([leakEpisodeStateSchema, z22.literal("flap_continuation")]),
  bucketAt: dateTimeSchema,
  /** `integratedLeak` at the moment of transition, m³. */
  volumeSnapshot: z22.number().nonnegative(),
  payload: z22.record(z22.unknown())
});

// src/comments/index.ts
var comments_exports = {};
__export(comments_exports, {
  COMMENT_MAX_LENGTH: () => COMMENT_MAX_LENGTH,
  commentAuthorSchema: () => commentAuthorSchema,
  commentIdSchema: () => commentIdSchema,
  commentSchema: () => commentSchema,
  commentWithAuthorSchema: () => commentWithAuthorSchema,
  updateCommentInputSchema: () => updateCommentInputSchema
});
import { z as z23 } from "zod";
var COMMENT_MAX_LENGTH = 5e3;
var commentSchema = z23.object({
  id: z23.string().uuid(),
  body: z23.string().trim().min(1).max(COMMENT_MAX_LENGTH),
  createdBy: z23.string().uuid().nullable(),
  createdAt: z23.string().datetime({ offset: true }),
  updatedAt: z23.string().datetime({ offset: true }),
  editedAt: z23.string().datetime({ offset: true }).nullable()
});
var commentAuthorSchema = z23.object({
  userId: z23.string().uuid(),
  fullName: z23.string().nullable(),
  email: z23.string(),
  pictureUrl: z23.string().nullable()
});
var commentWithAuthorSchema = commentSchema.extend({
  author: commentAuthorSchema.nullable()
});
var commentIdSchema = z23.object({
  commentId: z23.string().uuid()
});
var updateCommentInputSchema = commentSchema.pick({ body: true }).extend({
  commentId: z23.string().uuid()
});

// src/dashboard-card/index.ts
var dashboard_card_exports = {};

// src/dashboard-email-next-send.ts
var atSendHour = (day, sendHour) => day.set({ hour: sendHour, minute: 0, second: 0, millisecond: 0 });
var candidateDays = (timing, local) => {
  switch (timing.cadence) {
    case "daily":
      return [local, local.plus({ days: 1 })];
    case "weekly": {
      const thisWeek = local.plus({ days: (timing.weekday - local.weekday + 7) % 7 });
      return [thisWeek, thisWeek.plus({ weeks: 1 })];
    }
    case "monthly":
      return [local.set({ day: timing.monthDay }), local.plus({ months: 1 }).set({ day: timing.monthDay })];
  }
};
var nextSendAt = (timing, sendHour, timezone, after) => {
  const local = after.setZone(timezone);
  const [current, following] = candidateDays(timing, local).map((day) => atSendHour(day, sendHour));
  const next = (current > local ? current : following).toUTC();
  if (!next.isValid) throw new Error(`No valid send time in timezone ${timezone}`);
  return next;
};

// src/dashboard-email-schedule.ts
import { z as z24 } from "zod";
var MAX_DASHBOARD_EMAIL_RECIPIENTS = 20;
var dashboardEmailTimingSchema = z24.discriminatedUnion("cadence", [
  z24.object({ cadence: z24.literal("daily") }),
  z24.object({ cadence: z24.literal("weekly"), weekday: z24.number().int().min(1).max(7) }),
  z24.object({ cadence: z24.literal("monthly"), monthDay: z24.number().int().min(1).max(28) })
]);
var dashboardEmailScheduleFieldsSchema = z24.object({
  recipients: z24.array(z24.string().trim().toLowerCase().email()).min(1).max(MAX_DASHBOARD_EMAIL_RECIPIENTS).transform((recipients) => [...new Set(recipients)]),
  sendHour: z24.number().int().min(0).max(23),
  timing: dashboardEmailTimingSchema
});
var DASHBOARD_EMAIL_SCHEDULES_FLAG = "dashboard_email_schedules";

// src/dashboard-print.ts
import { z as z25 } from "zod";
var printLayoutSchema = z25.enum(["pdf", "public"]);

// src/data-coverage.ts
import { DateTime } from "luxon";
import { z as z26 } from "zod";
var DATA_COVERAGE_WINDOWS_DAYS = [7, 14, 30, 90];
var DATA_COVERAGE_ALERT_WINDOW_DAYS = 14;
var DATA_COVERAGE_LIST_WINDOWS_DAYS = [14, 30];
var DATA_COVERAGE_THRESHOLD = 0.95;
var DATA_COVERAGE_CRITICAL_THRESHOLD = 0.5;
var DATA_COVERAGE_MIN_EXPECTED_HOURS = 24;
var DATA_COVERAGE_SETTLE_HOURS = 24;
var DATA_COVERAGE_RECOMPUTE_DAYS = 3;
var dataCoverageListWindowSchema = z26.custom(
  (value) => DATA_COVERAGE_LIST_WINDOWS_DAYS.some((days) => days === value)
);
var dataCoverageFilterSchema = z26.enum(["silent", "critical", "below", "healthy"]);
var DATA_COVERAGE_FILTER_MATCHES = {
  silent: (ratio) => ratio === 0,
  critical: (ratio) => ratio < DATA_COVERAGE_CRITICAL_THRESHOLD,
  below: (ratio) => ratio < DATA_COVERAGE_THRESHOLD,
  healthy: (ratio) => ratio >= DATA_COVERAGE_THRESHOLD
};
var matchesDataCoverageFilter = (filter, ratio) => ratio !== null && DATA_COVERAGE_FILTER_MATCHES[filter](ratio);
var toCoverageDateTime = (at) => {
  const dateTime = typeof at === "number" ? DateTime.fromMillis(at, { zone: "utc" }) : DateTime.fromISO(at, { zone: "utc" });
  if (!dateTime.isValid) throw new Error(`Invalid coverage date: ${at}`);
  return dateTime;
};
var toCoverageDay = (at) => toCoverageDateTime(at).toISODate();
var coveredHoursBitsSchema = z26.string().regex(/^[01]{24}$/);
var HOURS_OF_DAY = Array.from({ length: 24 }, (_4, hour) => hour);
var toCoveredHoursBits = (coveredHours) => {
  const covered = new Set(coveredHours);
  return HOURS_OF_DAY.map((hour) => covered.has(hour) ? "1" : "0").join("");
};
var coveredHoursFromBits = (bits) => {
  const parsed = coveredHoursBitsSchema.parse(bits);
  return HOURS_OF_DAY.filter((hour) => parsed[hour] === "1");
};

// src/index.ts
var notificationSubscriptionSchema = z27.object({
  scope: z27.enum(["site", "group"]),
  id: z27.string(),
  topics: z27.string().array().default([])
});
var orgMemberNotificationPreferencesSchema = z27.object({
  mode: z27.literal("all")
}).or(
  z27.object({
    mode: z27.literal("custom"),
    subscriptions: z27.array(notificationSubscriptionSchema).default([])
  })
);
var commonDataSourcePropsSchema = z27.object({
  id: z27.string(),
  stationID: z27.string(),
  createdAt: dateTimeSchema,
  retiredAt: dateTimeSchema.nullable().default(null),
  notes: z27.string().nullable(),
  // Flow-only: how values arrive (register snapshots vs deltas), never what they mean —
  // interpretation flows from station.measurement_type via the registry (ADR-0007).
  readingMethod: z27.enum(["incremental", "cumulative"]),
  unit: z27.enum(["l", "m3"]),
  attachments: z27.string().array().optional()
});
var mappingQuerySchema = z27.string().min(1, "mappingQuery cannot be empty").regex(
  /^payload(\s*->\s*(\w+|"\d+"))*$/,
  `mappingQuery must start with "payload" and contain only alphanumeric words or double-quoted numeric literals separated by "->"'`
);
var MeterBaseConfigSchema = z27.object({
  deviceID: z27.string().min(1, "deviceID cannot be empty"),
  mappingQuery: mappingQuerySchema,
  pulseWeight: z27.number().optional()
});
var ShaypMeterConfigSchema = MeterBaseConfigSchema.extend({
  maker: z27.literal("shayp")
});
var AdeunisMeterConfigSchema = MeterBaseConfigSchema.extend({
  maker: z27.literal("adeunis"),
  channel: z27.enum(["A", "B"]).optional(),
  // Full Live Objects urn. Absent for the cellular fleet, where it derives from deviceID.
  streamId: z27.string().regex(/^urn:lo:nsid:[a-z0-9]+:.+$/i, "streamId must be a Live Objects urn").optional()
});
var pressureToLevelConversionSchema = z27.object({
  multiplier: z27.number().positive(),
  offset: z27.number()
});
var EfentoMeterConfigSchema = MeterBaseConfigSchema.extend({
  maker: z27.literal("efento"),
  measurementPointID: z27.number().nullable(),
  pulseWeight: z27.number(),
  channel: z27.number().int().positive().nullable(),
  mappingQuery: mappingQuerySchema.nullable(),
  conversion: pressureToLevelConversionSchema.optional()
});
var buildEfentoMappingQuery = (channel) => channel !== null ? `payload -> decoded -> ${channel}` : null;
var buildEfentoDataSourcePayload = (args) => ({
  stationID: args.stationID,
  sourceType: "meter",
  readingMethod: "incremental",
  unit: "l",
  config: {
    maker: "efento",
    deviceID: args.deviceSerialNumber,
    measurementPointID: args.measurementPointID ?? null,
    pulseWeight: args.pulseWeight,
    channel: args.channel,
    mappingQuery: buildEfentoMappingQuery(args.channel),
    conversion: args.conversion
  }
});
var WEENAT_RAINFALL_MAPPING_QUERY = "payload -> decoded -> RR";
var RAINFALL_PLACEHOLDER_UNIT = "m3";
var WeenatMeterConfigSchema = MeterBaseConfigSchema.extend({
  // Hand-entered configs carry only maker and deviceID (the serial); the id and model are bound later.
  maker: z27.literal("weenat"),
  weenatDeviceID: z27.number().int().positive().nullable().default(null),
  weenatModel: z27.string().nullable().default(null),
  mappingQuery: z27.literal(WEENAT_RAINFALL_MAPPING_QUERY).default(WEENAT_RAINFALL_MAPPING_QUERY),
  pulseWeight: z27.literal(1).default(1)
});
var buildWeenatDataSourcePayload = (args) => ({
  stationID: args.stationID,
  sourceType: "meter",
  readingMethod: "incremental",
  unit: RAINFALL_PLACEHOLDER_UNIT,
  config: {
    maker: "weenat",
    deviceID: args.serial,
    weenatDeviceID: args.weenatDeviceID,
    weenatModel: args.weenatModel,
    mappingQuery: WEENAT_RAINFALL_MAPPING_QUERY,
    pulseWeight: 1
  }
});
var KnownMeterConfigSchema = z27.discriminatedUnion("maker", [
  ShaypMeterConfigSchema,
  AdeunisMeterConfigSchema,
  EfentoMeterConfigSchema,
  WeenatMeterConfigSchema
]);
var DATA_COVERAGE_MAKERS = Object.freeze(
  KnownMeterConfigSchema.options.map(({ shape }) => shape.maker.value)
);
var LegacyMeterConfigSchema = MeterBaseConfigSchema.extend({
  maker: z27.string().refine((m) => !KnownMeterConfigSchema.optionsMap.has(m), {
    message: "Use the dedicated schema for known makers"
  })
});
var MeterConfigSchema = z27.union([KnownMeterConfigSchema, LegacyMeterConfigSchema]);
var MeterDataSourceSchema = commonDataSourcePropsSchema.extend({
  sourceType: z27.literal("meter"),
  config: MeterConfigSchema
});
var RainGaugeDataSourceSchema = MeterDataSourceSchema.extend({
  readingMethod: z27.literal("incremental"),
  unit: z27.literal(RAINFALL_PLACEHOLDER_UNIT),
  config: WeenatMeterConfigSchema
});
var ManualDataSourceSchema = commonDataSourcePropsSchema.extend({
  sourceType: z27.literal("manual"),
  config: manualDataSourceConfigSchema
});
var RainfallManualDataSourceSchema = ManualDataSourceSchema.extend({
  readingMethod: z27.literal("incremental"),
  unit: z27.literal(RAINFALL_PLACEHOLDER_UNIT)
});
var MetricDataSourceSchema = commonDataSourcePropsSchema.extend({
  sourceType: z27.literal("metric"),
  config: z27.object({
    metricID: z27.string().uuid()
  })
});
var APIDataSourceSchema = commonDataSourcePropsSchema.extend({
  sourceType: z27.literal("api"),
  config: z27.object({
    deviceID: z27.string().min(1, "deviceID cannot be empty"),
    mappingQuery: mappingQuerySchema,
    // Optional origin tag for ops display (e.g. 'occitaline'). Canonical
    // provenance is the data-lake `source` tag, not this field.
    provider: z27.string().optional()
  })
});
var DataSourceSchema = z27.discriminatedUnion("sourceType", [
  MeterDataSourceSchema,
  ManualDataSourceSchema,
  MetricDataSourceSchema,
  APIDataSourceSchema
]);
var GeoCoordinatesSchema = z27.object({
  lat: z27.number(),
  lng: z27.number()
});
var budgetObjectiveMeasure = z27.enum(["volume", "currency"]);
var budgetGoalMode = z27.enum(["cumulative", "per_period"]);
var goalType = z27.enum(["budget", "operational"]);
var baseGoalSchema = z27.object({
  id: z27.string().uuid(),
  type: goalType.default("budget"),
  name: z27.string().nullable().optional(),
  description: z27.string().nullable().optional(),
  startDate: z27.string().datetime({ offset: true }).nullable(),
  endDate: z27.string().datetime({ offset: true }).nullable(),
  upperThreshold: z27.number().positive(),
  lowerThreshold: z27.number().nullable().optional(),
  measure: budgetObjectiveMeasure,
  stationID: z27.string().uuid().optional(),
  dynamicMetricID: z27.string().uuid().optional(),
  resolution: resolutionSchema,
  customDistribution: z27.array(z27.number().min(0)),
  mode: budgetGoalMode.default("cumulative")
});
var goalTargetCount = (data) => [data.stationID, data.dynamicMetricID].filter(Boolean).length;
var createBudgetGoalSchema = baseGoalSchema.omit({ id: true }).refine((data) => goalTargetCount(data) === 1, {
  message: "Exactly one of stationID or dynamicMetricID must be provided",
  path: ["stationID", "dynamicMetricID"]
}).refine((data) => !data.dynamicMetricID || data.measure === "volume", {
  message: "Dynamic-metric goals only support volume measure",
  path: ["measure"]
});
var budgetGoalSchema = baseGoalSchema.extend({
  station: z27.object({
    id: z27.string().uuid(),
    name: z27.string()
  }).optional(),
  dynamicMetric: z27.object({
    id: z27.string().uuid(),
    name: z27.string(),
    unitLabel: z27.string()
  }).optional()
}).refine((data) => !data.dynamicMetricID || data.measure === "volume", {
  message: "Dynamic-metric goals only support volume measure",
  path: ["measure"]
});
var operationalGoalResolution = z27.enum(["hour", "day", "week"]);
var operationalGoalSchema = z27.object({
  id: z27.string().uuid(),
  type: z27.literal("operational"),
  name: z27.string().nullable().optional(),
  description: z27.string().nullable().optional(),
  startDate: z27.string().datetime({ offset: true }).nullable(),
  endDate: z27.string().datetime({ offset: true }).nullable(),
  upperThreshold: z27.number().positive().nullable().optional(),
  lowerThreshold: z27.number().positive().nullable().optional(),
  measure: z27.literal("volume"),
  stationID: z27.string().uuid().optional(),
  dynamicMetricID: z27.string().uuid().optional(),
  resolution: operationalGoalResolution,
  customDistribution: z27.array(z27.number().min(0)),
  mode: z27.literal("per_period"),
  station: z27.object({ id: z27.string().uuid(), name: z27.string() }).optional(),
  dynamicMetric: z27.object({ id: z27.string().uuid(), name: z27.string(), unitLabel: z27.string() }).optional()
});
var createOperationalGoalSchema = operationalGoalSchema.omit({ id: true, station: true, dynamicMetric: true }).extend({
  type: z27.literal("operational").default("operational"),
  measure: z27.literal("volume").default("volume"),
  mode: z27.literal("per_period").default("per_period"),
  startDate: z27.string().datetime({ offset: true }).nullable().optional(),
  endDate: z27.string().datetime({ offset: true }).nullable().optional()
}).refine((data) => data.upperThreshold != null || data.lowerThreshold != null, {
  message: "At least one of upperThreshold or lowerThreshold must be provided",
  path: ["upperThreshold"]
}).refine((data) => goalTargetCount(data) === 1, {
  message: "Exactly one of stationID or dynamicMetricID must be provided",
  path: ["stationID", "dynamicMetricID"]
});
export {
  APIDataSourceSchema,
  access_policies_exports as AccessPolicies,
  AdeunisMeterConfigSchema,
  comments_exports as Comments,
  consumption_corrections_exports as Corrections,
  custom_pages_exports as CustomPages,
  DASHBOARD_EMAIL_SCHEDULES_FLAG,
  DATA_COVERAGE_ALERT_WINDOW_DAYS,
  DATA_COVERAGE_CRITICAL_THRESHOLD,
  DATA_COVERAGE_LIST_WINDOWS_DAYS,
  DATA_COVERAGE_MAKERS,
  DATA_COVERAGE_MIN_EXPECTED_HOURS,
  DATA_COVERAGE_RECOMPUTE_DAYS,
  DATA_COVERAGE_SETTLE_HOURS,
  DATA_COVERAGE_THRESHOLD,
  DATA_COVERAGE_WINDOWS_DAYS,
  dashboard_card_exports as DashboardCard,
  data_lake_exports as DataLake,
  DataSourceSchema,
  dynamic_metrics_exports as DynamicMetrics,
  EfentoMeterConfigSchema,
  ftp_exports as Ftp,
  GeoCoordinatesSchema,
  leak_v0_exports as LeakV0,
  MAX_DASHBOARD_EMAIL_RECIPIENTS,
  MEASUREMENT_TYPES,
  ManualDataSourceSchema,
  MeterBaseConfigSchema,
  MeterConfigSchema,
  MeterDataSourceSchema,
  MetricDataSourceSchema,
  ops_exports as Ops,
  plugins_exports as Plugins,
  RAINY_DAY_THRESHOLD_MM,
  RainGaugeDataSourceSchema,
  RainfallManualDataSourceSchema,
  sites_exports as Sites,
  stations_exports as Stations,
  WEENAT_RAINFALL_MAPPING_QUERY,
  WeenatMeterConfigSchema,
  accessPolicyInputSchema,
  accessPolicySchema,
  bucketAggregationSchema,
  budgetGoalMode,
  budgetGoalSchema,
  buildEfentoDataSourcePayload,
  buildEfentoMappingQuery,
  buildWeenatDataSourcePayload,
  coveredHoursBitsSchema,
  coveredHoursFromBits,
  createBudgetGoalSchema,
  createOperationalGoalSchema,
  dashboardEmailScheduleFieldsSchema,
  dashboardEmailTimingSchema,
  dataCoverageFilterSchema,
  dataCoverageListWindowSchema,
  dateRangeSchema,
  dateTimeSchema,
  getMeasurementTypeSpec,
  goalType,
  inheritedFromSchema,
  mappingQuerySchema,
  matchesDataCoverageFilter,
  measurementChartKindSchema,
  measurementTypeSchema,
  memberRoleSchema,
  nextSendAt,
  notificationSubscriptionSchema,
  operationalGoalResolution,
  operationalGoalSchema,
  orgMemberNotificationPreferencesSchema,
  orgMemberScopeSchema,
  permissionSchema,
  pressureToLevelConversionSchema,
  printLayoutSchema,
  relativePeriodSchema,
  resolutionSchema,
  resourceTypeSchema,
  temporalSemanticSchema,
  toCoverageDateTime,
  toCoverageDay,
  toCoveredHoursBits
};
//# sourceMappingURL=index.js.map